/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmFineTuningCreate } from "../../funcs/llmFineTuningCreate.js";
import * as components from "../../models/components/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: components.CreateFineTuningJobRequest$inboundSchema,
};

export const tool$llmFineTuningCreate: ToolDefinition<typeof args> = {
  name: "llm-fine-tuning-create",
  description: `Create a fine-tuning job

Creates a fine-tuning job which begins the process of training a new model from a given dataset.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmFineTuningCreate(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
